import { render, staticRenderFns } from "./AlertCard.component.vue?vue&type=template&id=788e7dea"
import script from "./AlertCard.component.vue?vue&type=script&lang=js"
export * from "./AlertCard.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports